import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Plus, Check } from "lucide-react";

export default function WidgetGallery({ open, onClose, catalog, addedIds, onAdd }) {
  const categories = Array.from(new Set(catalog.map((w) => w.category)));
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto" data-testid="widget-gallery-dialog">
        <DialogHeader>
          <DialogTitle>Widget Library</DialogTitle>
          <DialogDescription>
            Pick widgets from the Cloud Economics catalog. You can add a widget more than once.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-5">
          {categories.map((cat) => (
            <div key={cat}>
              <div className="text-[10px] uppercase tracking-[0.14em] text-muted-foreground font-medium mb-2">{cat}</div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                {catalog.filter((w) => w.category === cat).map((w) => {
                  const added = addedIds.includes(w.id);
                  return (
                    <button
                      key={w.id}
                      data-testid={`gallery-add-${w.id}`}
                      onClick={() => onAdd(w)}
                      className="text-left border border-border rounded-sm p-3 hover:border-[#00579e] hover:bg-[hsl(var(--cs-tint))] transition-colors duration-150 group"
                    >
                      <div className="flex items-start justify-between gap-2">
                        <span className="text-sm font-medium text-foreground leading-snug">{w.title}</span>
                        {added ? (
                          <Check className="w-4 h-4 text-[#15803d] shrink-0 mt-0.5" />
                        ) : (
                          <Plus className="w-4 h-4 text-muted-foreground group-hover:text-[#00579e] shrink-0 mt-0.5" />
                        )}
                      </div>
                      <div className="text-[11px] text-muted-foreground mt-1 leading-snug">{w.description}</div>
                      <div className="text-[10px] uppercase tracking-[0.12em] text-muted-foreground mt-1.5 cs-mono">
                        {w.kind.replace("_", " ")}
                      </div>
                    </button>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
